// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main_content[data-v-afbf2e28]{background:#fff;width:100%;height:100%;display:flex;justify-content:center;align-items:center}.main_content .center[data-v-afbf2e28]{font-size:16px;text-align:center;width:300px;line-height:22px;letter-spacing:.5px;margin:0 auto}.main_content .tip_img[data-v-afbf2e28]{width:93px;height:75px;margin-bottom:6px}", ""]);
// Exports
module.exports = exports;
